<div class="modal-header bg-tertiary">
  <div class="overflow-hidden">
    <h6 class="modal-title fw-bold">Your invoice</h6>
    <div class="small text-muted text-truncate">
      {{ billingRequest.startingAt | date: 'dd/MM/yyyy' }} - {{ billingRequest.endingAt | date: 'dd/MM/yyyy' }}
      @if (invoice.reference) {
        · Ref. {{ invoice.reference }}
      }
    </div>
  </div>
  <button (click)="close()" [disabled]="uploading" type="button" class="btn-close" aria-label="Close"></button>
</div>

<div class="modal-body position-relative"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">
  @if (previewUrl || loadingPreview) {
    <div class="d-flex align-items-center gap-3 mb-3">
      <i class="bi fs-2" [ngClass]="isPdfPreview() ? 'bi-file-earmark-pdf text-danger' : 'bi-file-earmark-image text-primary'"></i>
      <div class="flex-grow-1 overflow-hidden">
        <div class="fw-bold text-truncate" [title]="previewFilename">{{ previewFilename }}</div>
        <div class="small text-muted">
          @if (pendingFile) {
            {{ getFileSize(pendingFile) }} · <span class="text-warning fw-bold">Not saved yet</span>
          } @else {
            Uploaded on {{ $safeNavigationMigration(invoiceFile?.createdAt) | date: 'dd/MM/yyyy HH:mm' }}
          }
        </div>
      </div>
      @if (!pendingFile && storedFileUrl) {
        <div class="d-flex gap-2 flex-shrink-0">
          <a [href]="storedFileUrl" target="_blank" rel="noopener" title="Open in a new tab"
            class="btn btn-outline-primary btn-sm">
            <i class="bi bi-box-arrow-up-right"></i>
          </a>
          <a [href]="storedFileUrl" [download]="$safeNavigationMigration(invoiceFile?.filename)" title="Download the file"
            class="btn btn-outline-primary btn-sm">
            <i class="bi bi-download"></i>
          </a>
          <label class="btn btn-primary btn-sm fw-bold mb-0" title="Replace the file">
            <i class="bi bi-arrow-repeat me-1"></i>Replace
            <input type="file" class="d-none" [accept]="acceptedTypes" (change)="onFileSelected($event)">
          </label>
        </div>
      }
    </div>

    @if (pendingFile && invoiceFile) {
      <div class="alert alert-warning py-2 small mb-3">
        <i class="bi bi-exclamation-triangle me-1"></i>
        The current file <span class="fw-bold">{{ invoiceFile.filename }}</span> will be replaced once the upload is confirmed.
      </div>
    }

    <div class="preview border rounded bg-light d-flex align-items-center justify-content-center">
      @if (loadingPreview) {
        <div class="text-muted"><span class="spinner-border spinner-border-sm me-2"></span>Loading the file...</div>
      } @else if (previewUrl && isPdfPreview()) {
        <iframe [src]="previewUrl | safe: 'resourceUrl'" [title]="previewFilename"></iframe>
      } @else if (previewUrl && isImagePreview()) {
        <img [src]="previewUrl" [alt]="previewFilename">
      } @else {
        <div class="text-muted">The file cannot be previewed.</div>
      }
    </div>
  } @else {
    <label class="d-block upload-area border border-2 rounded p-5 text-center bg-light">
      <i class="bi bi-cloud-arrow-up fs-1 text-primary"></i>
      <p class="mt-3 mb-1 fw-bold">Drag and drop your own invoice here or click to upload</p>
      <p class="small text-muted mb-0">PDF, JPEG, PNG or WEBP · 10 MB max</p>
      <input type="file" class="d-none" [accept]="acceptedTypes" (change)="onFileSelected($event)">
      <span class="btn btn-primary mt-3 fw-bold">Choose a file</span>
    </label>
  }

  @if (dragging) {
    <div class="drop-overlay rounded">
      <i class="bi bi-cloud-arrow-down fs-1 text-primary"></i>
      <p class="mt-2 mb-0 fw-bold">Drop the file to {{ invoiceFile ? 'replace' : 'upload' }} your invoice</p>
    </div>
  }
</div>

<div class="modal-footer bg-tertiary">
  @if (pendingFile) {
    <button (click)="cancelPendingFile()" [disabled]="uploading" type="button" class="btn btn-outline-primary fw-bold">
      Cancel
    </button>
    <button (click)="upload()" [disabled]="uploading" type="button" class="btn btn-primary fw-bold">
      @if (uploading) {
        <span class="spinner-border spinner-border-sm me-2"></span>
      } @else {
        <i class="bi bi-cloud-arrow-up me-2"></i>
      }
      {{ invoiceFile ? 'Replace the file' : 'Upload the file' }}
    </button>
  } @else {
    <button (click)="close()" type="button" class="btn btn-outline-primary fw-bold">Close</button>
  }
</div>
